<template>
  <div class="stateInventory responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader title="Cash Reconciliation By Workstation" :links="[
        { name: 'home', label: 'Home' },
        { name: 'reports', label: 'Reports' },
        { name: 'financeReport', label: 'Finance' },
        {
          name: 'cashReconciliationByWorkstation',
          label: 'Cash Reconciliation by Workstation',
        },
      ]" @export="exportToCsv" :disableExport="!reportData" />
      <br class="no-print" />
      <ReportFilter class="no-print" :filterByTime="true" @submit-filter="performGetReport" :isLoading="isLoading"
        :percentage="percentageCompleted" :filterBySaleType="false" :filterByStoreOrOrg="false" />
      <div class="report-container">
        <!-- This could be a component -->
        <div class="report-body" v-if="reportData">
          <table id="table-report">
            <thead>
              <tr>
                <th align="left">Date</th>
                <th align="left">Workstation</th>
                <th align="right">Cash Payment</th>
                <th align="right">Debit Payment</th>
                <th align="right">CM Payment</th>
                <th align="right">Gift Card Payment</th>
                <th align="right">Sales Total</th>
                <th align="right">Refunds</th>
              </tr>
            </thead>
            <tbody>
              <tr class="report-body__row"></tr>
              <tr v-for="(data, index) of formattedData" :key="index" :class="{ total2: data.isTotal }">
                <td>{{ data.date }}</td>
                <td v-if="!data.isTotal">{{ data.workstationId }}</td>
                <td v-else>Totals</td>
                <td align="right">{{ formatAmount(data.cashPayment + data.cashPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.debitPayment + data.debitPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.creditMemoPayment + data.creditMemoPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.giftCardPayment + data.giftCardPaymentReversed) }}</td>
                <td align="right">{{ formatAmount(data.order + data.orderReversed) }}</td>
                <td align="right">{{ formatAmount(data.orderRefund + data.orderRefundReversed) }}</td>
              </tr>
            </tbody>
            <tr class="skip-export"></tr>
            <tr>
              <td colspan="2">Grand Totals</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.cashPayment + reportData.total.cashPaymentReversed) }}</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.debitPayment + reportData.total.debitPaymentReversed) }}</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.creditMemoPayment + reportData.total.creditMemoPaymentReversed)
                }}</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.giftCardPayment + reportData.total.giftCardPaymentReversed) }}
              </td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.order + reportData.total.orderReversed) }}</td>
              <td align="right">
                {{ Utilities.formatPrice(reportData.total.orderRefund + reportData.total.orderRefundReversed) }}
              </td>
            </tr>
            <tr class="skip-export"></tr>
            <tr class="skip-export">
              <td colspan="100%">
                <hr class="line1" />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/Header/Header.vue";
import { mapActions, mapGetters } from "vuex";
import ReportFilter from "@/components/ReportFilter/ReportFilter";
import Utilities from "@/lib/Utilities";
import ReportHelper from "@/lib/report/index.js";

export default {
  data() {
    return {
      Utilities,
    };
  },
  components: {
    PageHeader,
    ReportFilter,
  },
  created: function () {
    this.setPageTitle("Cash Reconciliation By Workstation");
  },
  computed: {
    ...mapGetters({
      isLoading: "reports/isLoading",
      getData: "reports/getData",
      percentageCompleted: 'reports/percentageCompleted'
    }),
    reportData() {
      return this.getData;
    },
    formattedData() {
      const data = this.reportData;
      let rows = []

      for (let [day, dayValue] of Object.entries(data.list)) {
        for (let [workstationId, workstation] of Object.entries(dayValue.workstations)) {
          rows.push(workstation)
        }
        rows.push({ ...dayValue.total, isTotal: true })
      }

      return rows;
    }
  },
  methods: {
    ...mapActions({
      generateReport: "reports/generate",
      clearData: "reports/clearData",
    }),
    performGetReport(filter) {
      let reportType = "cashReconciliationByWorkstation";
      this.generateReport({
        reportType,
        ...filter,
      });
    },
    formatAmount(value) {
      return value.toFixed(2)
    },
    exportToCsv() {
      var table = document.getElementById("table-report");
      ReportHelper.exportToExcel(table, "cashReconciliationByWorkstation");
    },
  },
  beforeDestroy() {
    this.clearData()
  }
};
</script>

<style lang="scss">
@import "./_cashReconciliationByWorkstation.scss";
</style>